import axios from 'axios';

import { FetchStatus } from '@powdr/constants';
import { getNodeApiDomain } from '@powdr/utils';

import { LEADERBOARD_PENDING, LEADERBOARD_SUCCESS, LEADERBOARD_ERROR } from '../types';

export const getLeaderboard = () => async (dispatch, getState) => {
  const leaderboardStatus = getState().leaderboard.status;

  // If more than one component calls the same feed make sure we only make one request
  if (leaderboardStatus !== FetchStatus.LOADING && leaderboardStatus !== FetchStatus.PENDING) {
    try {
      dispatch({
        type: LEADERBOARD_PENDING,
        payload: [],
      });

      const res = await axios.get(`${getNodeApiDomain()}/dor/leaderboard`);

      dispatch({
        type: LEADERBOARD_SUCCESS,
        payload: res.data?.boards?.[0] || [],
      });
    } catch (error) {
      dispatch({
        type: LEADERBOARD_ERROR,
        payload: error,
      });
    }
  }
};
